export const freightRateGroupSeparator = " ==> ";
